'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var hqoTheme = require('./hqo-theme-79db6cc8.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var HqoThemeProvider = function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? hqoTheme.hqoTheme : _b;
    return (React__default.createElement(styled.ThemeProvider, { theme: theme }, children));
};

exports.HqoThemeProvider = HqoThemeProvider;
